<template>
    <div class="">
        <div class="form-group">
            <label>Titel des Blocks</label>
            <input type="text" class="form-control" v-model="config.title" placeholder="Verkaufspreise">
        </div>

        <fieldset class="border px-3 mb-3">
            <legend class="w-auto">Sell-Out</legend>

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['verkauf.leftBase']"></i>
                            <b>Referenzpreis</b>
                        </label>
                        <select class="form-control" v-model="config.sellOutLeftBase">
                            <option value="listenVk">Listen VK</option>
                            <option value="kalkulierterVk">Kalkulierter VK</option>
                            <option value="tatsaechlicherVk">Tatsächlicher VK</option>
                        </select>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['verkauf.rightBase']"></i>
                            <b>Vergleichspreis</b>
                        </label>
                        <select class="form-control" v-model="config.sellOutRightBase">
                            <option value="listenVk">Listen VK</option>
                            <option value="kalkulierterVk">Kalkulierter VK</option>
                            <option value="tatsaechlicherVk">Tatsächlicher VK</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label>
                    <i class="fas fa-info-circle text-muted"
                       style=""
                       data-toggle="tooltip"
                       data-placement="top"
                       :title="$info['verkauf.compare']"></i>
                    <b>Bedingung</b>
                </label>
                <select class="form-control" v-model="config.compareOperator">
                    <option value="none">Keine</option>
                    <option value="equal">Vergleichspreis = (Gleich) Referenzpreis</option>
                    <option value="lower">Vergleichspreis &lt; (Kleiner) Referenzpreis</option>
                    <option value="greater">Vergleichspreis &gt; (Größer) Referenzpreis</option>
                </select>
            </div>

            <div v-if="!['none', 'equal'].includes(config.compareOperator)">
                <div class="form-group">
                    <label><b>Vergleich</b></label>
                    <select class="form-control" v-model="config.compareMode">
                        <option value="relative">Relativ (Prozent)</option>
                        <option value="absolute">Absolut (Euro)</option>
                    </select>
                </div>

                <div class="row mb-3">
                    <div class="col">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Min. Abweichung {{ limitUnit }}</span>
                            </div>
                            <input type="text" class="form-control" placeholder="0"
                                   v-model="config.lowerLimit">
                        </div>
                    </div>
                    <div class="col">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Max. Abweichung {{ limitUnit }}</span>
                            </div>
                            <input type="text" class="form-control" placeholder="50"
                                   v-model="config.upperLimit">
                        </div>
                    </div>
                </div>
            </div>

        </fieldset>

        <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
            <label>Sichtbare Spalten:</label>
            <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                <input class="form-check-input"
                       type="checkbox"
                       :id="id(column.id)"
                       :value="column.id"
                       :checked="!config.hiddenColumns.includes(column.id)"
                       @change="toggleHiddenColumns(column.id, $event)">
                <label class="form-check-label" :for="id(column.id)">
                    {{ column.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import blockMixin from "./blockMixin";

export default {
    components: {},
    mixins: [blockMixin],
    props: {

    },
    data() {
        return {
            config: this.dto
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        selectableVisibleColumns() {
            return [
                {id: 'absatz', label: 'Absatz'},
            ];
        },
    }
}
</script>
